import { render, staticRenderFns } from "./NavigationModule.vue?vue&type=template&id=6df367a3&"
import script from "./NavigationModule.ts?vue&type=script&lang=ts&"
export * from "./NavigationModule.ts?vue&type=script&lang=ts&"
import style0 from "./NavigationModule.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports